const { errors } = require('@transfeeradev/api-enums');
const error = require('../error');
const success = require('../success');
const Parser = require('../Parser');

class HeaderValidation {
  constructor(data, headers) {
    this._data = data;
    this._headers = headers;
    this._parser = new Parser(this._data);
    this._expectedHeadersFormatted = this._parser.getHeadersFormatted(this._headers);
    this._headersFormatted = this._parser.getHeadersFormatted();
  }

  validate() {
    const parsedHeaders = this._parser.getHeaders();

    const lengthValidationResult = this._isLengthValid(parsedHeaders);

    if (!lengthValidationResult.isValid) {
      return lengthValidationResult;
    }

    const mappedHeadersValidationResult = this._areAllHeadersMapped();

    if (!mappedHeadersValidationResult.isValid) {
      return mappedHeadersValidationResult;
    }

    const requiredHeaderValidation = this._wereAllRequiredHeadersProvided();

    if (!requiredHeaderValidation.isValid) {
      return requiredHeaderValidation;
    }

    return success;
  }

  _isLengthValid(parsedHeaders) {
    if (parsedHeaders.length < this._getRequiredHeaders().length || parsedHeaders.length > this._headers.length) {
      return error(errors.ptBr.she.HEADERS_LENGTH_ERROR_MESSAGE);
    }

    return success;
  }

  _areAllHeadersMapped() {
    const exists = this._existsHeaderInList(this._headersFormatted, this._expectedHeadersFormatted);

    if (!exists) {
      return error(errors.ptBr.she.HEADER_NOT_MAPPED);
    }

    return success;
  }

  _wereAllRequiredHeadersProvided() {
    const exists = this._existsHeaderInList(this._getRequiredHeaders(), this._headersFormatted);

    if (!exists) {
      return error(errors.ptBr.she.REQUIRED_HEADER_NOT_PROVIDED);
    }

    return success;
  }

  _existsHeaderInList(list1, list2) {
    for (let list1Index in list1) {
      let headerExists = false;

      for (let list2Index in list2) {
        const item1 = this._getItemDescription(list1[list1Index]);
        const item2 = this._getItemDescription(list2[list2Index]);
        const foundHeader = Boolean(item1 === item2);

        if (foundHeader) {
          headerExists = true;
          break;
        }
      }

      if (!headerExists) {
        return false;
      }
    }

    return true;
  }

  _getItemDescription(item) {
    return item.description ? item.description : item;
  }

  _getRequiredHeaders() {
    return this._expectedHeadersFormatted.filter(header => {
      if (!header.optional) {
        return header;
      }
    });
  }
}

module.exports = HeaderValidation;
